import { FilterProperties } from '@/entities/catalog-brands'

import { ApplyFilter } from '../types/types'

export const appliedFiltersAdapter = (properties: FilterProperties[]): ApplyFilter[] =>
	properties?.reduce((acc, obj) => {
		const checkedValues = obj.VALUES.filter(val => val.CHECKED)

		if (checkedValues.length) {
			checkedValues.forEach(({ VALUE, ID, FILTERED_VALUE }) =>
				acc.push({
					name: obj.NAME,
					code: obj.CODE,
					displayType: obj.DISPLAY_TYPE,
					id: ID,
					value: FILTERED_VALUE || VALUE
				})
			)
		}

		return acc
	}, [])
